import React from 'react';
import './product-drop-card.scss';
import Util from '../../utils/util'
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import lockIcon from "../../static/lock.svg";
import lockIconWhite from '../../static/lock-white.svg';
import CoachxMarvel_Module_bg from '../../static/CoachxMarvel_Module_bg.gif';
import Coach_x_MBJ_Module_bg from '../../static/Coach_x_MBJ_Module_bg.png';
import Marvel_Content from '../../static/Marvel_Content.PNG';
import Coach_x_Disney from '../../static/Coach_x_Disney.gif';
import CoachReserve from '../../static/CoachReserve.gif';
import MBJ_Collaboration_NARUTO_LOGO_White from '../../static/MBJ_Collaboration_NARUTO_LOGO_White.svg';
import Coach_Cabin_Module_2 from '../../static/Coach_Cabin_Module_New.jpg';
import productDropLockIcon from '../../static/productDropLockIcon.svg';
import productDropLockIconWhite from '../../static/productDropLockIconWhite.svg';
import brightIdeasImage from '../../static/bright2.jpg';
import sweetSurprisesImage from '../../static/sweet.JPG';
import wildThingsImage from '../../static/wild.JPG'; 
// import georgie from '../../static/georgie.JPG';


class ProductDropCard extends React.Component {

    // function which returns eventlisteners for product drops cta
    ctaClickFactory = (ctaObj) => {

        return () => {

            if (ctaObj.action) {
                Util.gotoRoute(ctaObj.action, this.props.history);
                if (ctaObj.analyticsEvent) {
                    dataLayer.push(ctaObj.analyticsEvent);
                }
            }
        }
    }
  
    render () {

        let card = {};
        let common = {};
        const selectedLanguage = Util.getSelectedLanguage();

        if (this.props.locale && this.props.locale.screens) {
            card = this.props.locale.screens.productDropCard;
            common = this.props.locale.screens.common;
        }


        const { position, selectedIndex, data } = this.props;
        const isUserLoggedIn = Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN; 

        /*
            2 states are there, states can be used when we want to show a different drop after an event occured
            eg. after user logged in, the drop should change with no cta is present
        */

        const markupState = !isUserLoggedIn ? 'state0' : 'state1';

        let ctaClickListener = () => {};
        if (data && data.content && data.content[markupState] && data.content[markupState] && data.content[markupState].cta) {
            ctaClickListener = this.ctaClickFactory(data.content[markupState].cta);
        }

        

        return (
            <>
                {
                    data && data.content &&  data.content[markupState] && data.content[markupState][selectedLanguage] ? 
                    
                        <div aria-hidden={position == selectedIndex ? false : true}
                            onClick={ctaClickListener}
                            dangerouslySetInnerHTML={{__html: data.content[markupState][selectedLanguage]}} />
                    : ''
                }
            </>
        );

    }
}

const mapStateToProps = state => {
    return {
        locale: state.locale
    };
};
  
const mapDispatchToProps = dispatch => {
    return {};
};
  
  const connectedProductDropCard = connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(ProductDropCard));

export default connectedProductDropCard;